import React, { useState } from 'react';
import { Mic, ArrowRight } from 'lucide-react';
import './HeroPrompt.css';

export default function HeroPrompt({ onSubmit, loading }) {
  const [prompt, setPrompt] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (prompt.trim() && !loading) onSubmit(prompt.trim());
  };

  return (
    <section className="hero">
      <div className="hero-bg">
        <div className="hero-orb hero-orb-1" />
        <div className="hero-orb hero-orb-2" />
        <div className="hero-grid" />
      </div>

      <div className="hero-content">
        <h1 className="hero-title animate-in">
          Describe your project.<br />
          <span className="hero-title-accent">Get every component.</span>
        </h1>
        <div className="hero-typewriter mono animate-in">From idea to BOM in one flow.</div>

        <p className="hero-sub animate-in">
          Tell us what you want to build — we'll find all required components<br />
          across Robu, RoboCraze, Quartz, and more Indian stores.
        </p>

        <form className="prompt-form animate-in" onSubmit={handleSubmit}>
          <div className="prompt-box">
            <div className="prompt-icon">
              <Mic size={18} />
            </div>
            <textarea
              className="prompt-input"
              placeholder="e.g. I want to build a smart home system that controls lights and fans using my phone..."
              value={prompt}
              onChange={e => setPrompt(e.target.value)}
              rows={3}
              onKeyDown={e => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSubmit(e);
                }
              }}
            />
          </div>
          <button className="prompt-btn glassy-btn" type="submit" disabled={!prompt.trim() || loading}>
            {loading ? (
              <span className="btn-loading">
                <span className="spinner" />
                <span>Analyzing...</span>
              </span>
            ) : (
              <>
                <span>Find Components</span>
                <ArrowRight size={16} />
              </>
            )}
          </button>
        </form>

      </div>
    </section>
  );
}
